import { config } from "zod/v4/core"

// Zod probes `new Function("")` on the first object parse to decide whether it
// can compile fast validators. Our CSP has no 'unsafe-eval', so the probe is
// blocked and the browser reports a script-src violation on every page load
// (about 90 a day in the web logs, at error level). jitless skips the probe;
// form-sized schemas don't need the compiled path.
config({ jitless: true })
